import { render, staticRenderFns } from "./FulfillmentMain.vue?vue&type=template&id=5d23ec1e"
import script from "./FulfillmentMain.vue?vue&type=script&lang=js"
export * from "./FulfillmentMain.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentMain.vue?vue&type=style&index=0&id=5d23ec1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports